export const VULNERABILITY_STATUS_ID = {
  OPEN: 0,
  FIXED: 1,
  ACKNOWLEDGED: 2,
  MITIGATED: 3,
}

export const VULNERABILITY_STATUS_COLOR = {
  [VULNERABILITY_STATUS_ID.OPEN]: '#AA4700',
  [VULNERABILITY_STATUS_ID.FIXED]: '#4BA03E',
  [VULNERABILITY_STATUS_ID.ACKNOWLEDGED]: '#002B9A',
  [VULNERABILITY_STATUS_ID.MITIGATED]: '#D6AE1B',
}

export const SEVERITY = [
  { value: '0', label: 'High' },
  { value: '1', label: 'Medium' },
  { value: '2', label: 'Low' },
  { value: '3', label: 'Informational' },
  { value: '4', label: 'Undetermined' },
]

export const SEVERITY_ID = {
  HIGH: 0,
  MEDIUM: 1,
  LOW: 2,
  INFORMATIONAL: 3,
  UNDETERMINED: 4,
}

export const SEVERITY_DESCRIPTION = {
  [SEVERITY_ID.HIGH]:
    "High-severity issues usually put a large number of users' sensitive information at risk, " +
    "or are reasonably likely to lead to catastrophic impact for client's reputation or serious " +
    'financial implications for client and users.',
  [SEVERITY_ID.MEDIUM]:
    "Medium-severity issues tend to put a subset of users' sensitive information at risk, would be detrimental " +
    "for the client's reputation if exploited, or are reasonably likely to lead to moderate financial impact.",
  [SEVERITY_ID.LOW]:
    'The risk is relatively small and could not be exploited on a recurring basis, or is a risk that the client ' +
    "has indicated is low impact in view of the client's business circumstances.",
  [SEVERITY_ID.INFORMATIONAL]:
    'The issue does not post an immediate risk, but is relevant to security best' +
    ' practices or Defence in Depth.',
  [SEVERITY_ID.UNDETERMINED]: 'The impact of the issue is uncertain.',
}

export const FINDING_HTML_ID_ATTRIBUTE = 'findings-qs'

export const OTHER_TITLE_ID = 30

export const UPDATE_STATUS = [
  {
    value: 'info',
    label: 'Informational',
  },
  {
    value: 'success',
    label: 'Fixed',
  },
  {
    value: 'warning',
    label: 'Alert',
  },
]

export const AUDIT_TYPE = {
  NORMAL: 0,
  SECURITY_REVIEW: 1,
}

export const QUALITY_ASSESMENT_LEVELS = {
  UNDETERMINED: '0',
  LOW: '1',
  MEDIUM: '2',
  HIGH: '3',
}

export const QUALITY_ASSESMENT_OPTIONS = [
  { value: QUALITY_ASSESMENT_LEVELS.UNDETERMINED, label: 'Undetermined' },
  { value: QUALITY_ASSESMENT_LEVELS.LOW, label: 'Low' },
  { value: QUALITY_ASSESMENT_LEVELS.MEDIUM, label: 'Medium' },
  { value: QUALITY_ASSESMENT_LEVELS.HIGH, label: 'High' },
]

export const REPO_TYPE = {
  REGULAR: 'regular',
  CUSTOM: 'custom',
}
